import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';
import { documentEndpoint } from '~/api/def/endpoints/document/documentEndpoint';

export const endpointFundDocumentUrlGET = async (docId: string) => {
  return await endpointFundDocumentUrlExec<'GET'>({
    method: 'GET',
    urlExtra: `/${docId}/view`,
  });
};
const endpointFundDocumentUrlExec =
  getExecEndpoint<FundDocumentUrlEndpointDef>(documentEndpoint);

interface FundDocumentUrlEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    GET: {
      response: GetFundDocumentUrlResponse;
    };
  };
}

export type GetFundDocumentUrlResponse = BqResponse<{
  data: DocumentUrlAPIModel;
}>;

export type DocumentUrlAPIModel = {
  documentId: string;
  presignedUrl: string;
};
